import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { CurriculaService } from 'app/services';

@Component({
  selector: 'app-comment',
  templateUrl: './comment.component.html',
  styleUrls: ['./comment.component.scss']
})
export class CommentComponent implements OnInit {
  @Input() comment: string = null;
  @Input() applicationId: number = null;
  @Output() savedComment: EventEmitter<string> = new EventEmitter<string>();

  public commentForm = new FormGroup(
    {comment: new FormControl(this.comment)}
  );

  public isInEditing: boolean = false;

  constructor(
    private curriculaService: CurriculaService
  ) { }

  ngOnInit() {
    if (!this.comment) {
      this.isInEditing = true;
    } else {
      this.commentForm.patchValue({comment: this.comment});
      this.isInEditing = false;
    }
  }

  async onSubmit() {
    await this.curriculaService.putApplicationComment(this.applicationId, this.commentForm.getRawValue().comment).toPromise();
    this.savedComment.emit(this.commentForm.getRawValue().comment);
    this.comment = this.commentForm.getRawValue().comment;
    this.ngOnInit()
  }

}
